import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Form,
    Select,
    Input,
    Divider,
    // Switch,
    Space,
    Radio,
} from 'antd'
import { useNavigate } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { validateSpaces } from '../../Utils/Common';

const { Option } = Select;
const { Item } = Form;

const AddRentalUnit = () => {
    const [addForm] = Form.useForm();
    const { callPost, loading } = usePostRequest(()=>{
        addForm.resetFields();
        navigate('/rental-unit')
    });
    const navigate = useNavigate()
    // const [isOwner, setIsOwner] = useState(false);
    // const [isManage, setIsManage] = useState(false);
    // const [manageType, setManageType] = useState(true);
    const [rentalDetails, setRentalDetails] = useState({
        name: '',
        property_id:'',
        property_address:'',
        property_type: '',
        description: '',
        pricing_type: 'som',
    });
    const [propertyData, setPropertyData] = useState([])
    const [ownerData, setOwnerData] = useState([])
    const bedrooms_data = [
        {
            id: "1",
            name: "Studio",
        },
        {
            id: "2",
            name: "Loft",
        },
        {
            id: "3",
            name: "Penthouse",
        },
        {
            id: "4",
            name: "1",
        },
        {
            id: "5",
            name: "2",
        },
        {
            id: "6",
            name: "3",
        },
        {
            id: "7",
            name: "4",
        },
        {
            id: "8",
            name: "5",
        },
    ]

    async function fetchPropertyData  () {
        // setIsLoading(true)

        const response = await UseGetRequest("properties/get", {property_id: ''});
        if (response?.data) {
          setPropertyData(response?.data?.data);
        } else {
          setPropertyData([])
        }
    
        // setIsLoading(false);
    }
    async function fetchOwnerData() {
        // setIsLoading(true)

        const response = await UseGetRequest("owners/get", {owner_id: ''});
        if (response?.data) {
          setOwnerData(response?.data?.data);
        } else {
          setOwnerData([])
        }
    
        // setIsLoading(false);
    }
    const handlePricingTypeChange = (value) => {
        setRentalDetails({
          ...rentalDetails,
          pricing_type: value,
        });
    }
    const handleOwnerType = (value) => {
        const details = ownerData.find(item => item.id === value);
        setRentalDetails({
          ...rentalDetails,
          owner_id: details?.id, 
          contact_no: details?.contact_no,
          address: details?.address,
        });
        addForm.setFieldsValue({
            owner_id: details.id,
            contact_no: details.contact_no,
            address: details.address,
        })
    };

    const options = [
        { label: 'Fully Furnished', value: 'fully' },
        { label: 'Semi Furnished', value: 'semi' },
        { label: 'Unfurnished', value: 'unfurnished' },
    ];

    const insurance = [
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' },
    ];

    const handleAddRentalUnit = () => {
        addForm.validateFields().then(values => {
            const newValues = {
                ...(values.alfresco_area && { alfresco_area: values.alfresco_area }),
                ...(values.cusa_area && { cusa_area: values.cusa_area }),
                ...(values?.owner_id && { owner_id: values?.owner_id }),
                description: values.description,
                floor_area: values.floor_area || '',
                bathrooms: values.bathrooms,
                bedrooms: values.bedrooms,
                furnishing: values.furnishing,
                name: values.name,
                pricing_type: values.pricing_type,
                unit_price: values.unit_price,
                property_address: values.property_address,
                property_name: values.property_name,
                with_insurance: values.with_insurance,
                property_type: values.property_type,
                space_area: values.space_area,
                property_id: rentalDetails.property_id,
                management_fee: values.management_fee,
                agent_fee: values.agent_fee,
                remarks: values.remark,
                // is_managed: isManage,
                // manage_type: manageType ? "percentage" : "fixed",
                status: 'vacant',
            }
            callPost(
                "rental_units/create", 
                newValues,
                false,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed ', errorInfo);
        });
    };
    const handlePropertyType = (value) => {
        var type = ''
        const details = propertyData.find(item => item.id === value);
        if(details.property_type === 'commercial_building'){
            type = 'Commerical Building'
        } else if (details.property_type === 'residential_building') {
            type = 'Residential Building'
        } else if (details.property_type === 'raw_lot') {
            type = 'Raw Lot'
        } else if (details.property_type === 'condominium') {
            type = 'Condominium'
        }
        setRentalDetails({
          ...rentalDetails,
          property_id: details.id,
          property_address: details.address,
          property_type: type,
        });
        addForm.setFieldsValue({
            property_address: details.address,
            property_type: type,
            property_id: details.id,
            property_name: details.name,
        })
    };
    useEffect(() => {
        fetchPropertyData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
    useEffect(() => {
        // if(isOwner){
            fetchOwnerData();
        // }
    }, [
        // isOwner
    ]);
  return (
    <Layout className='page'>
        <Navbar/>
        <Layout className='content-container overflow-y p-4'>
            <Row>
                <Col span={24} className='header-container'>
                    ADD RENTAL UNIT
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Form 
                        initialValues={rentalDetails} 
                        form={addForm} 
                        layout="vertical"
                    >
                        <Divider className='divider-text'>Unit Information</Divider>
                        <Row className='responsive-inline responsive-width'>
                            <Col span={8} className='p-2'>
                                <Item
                                    label="Unit Number"
                                    name="name"
                                    className='p-0 m-0'
                                    rules={[
                                        { required: true, message: 'Please enter your Name!' },
                                        { validator: validateSpaces }
                                    ]}
                                >
                                    <Input/>
                                </Item>
                                {/* <Button 
                                    type="link" 
                                    htmlType="button" 
                                    className='p-0'
                                    onClick={() => setIsOwner(!isOwner)}
                                >
                                    ADD OWNER
                                </Button> */}
                                {/* <Switch
                                    checked={isOwner}
                                    checkedChildren="With Owner"
                                    unCheckedChildren="Add Owner"
                                    size='medium'
                                    className='mt-2 me-4'
                                    style={{ backgroundColor: isOwner ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                    onChange={() => {
                                        setIsOwner(!isOwner);
                                    }}
                                /> */}
                            
                            </Col>
                            <Col span={5} className='p-2'>
                                <Item
                                    label="Property"
                                    name="property_name"
                                    rules={[
                                        { required: true, message: 'Please enter your Property Name!' },
                                        { validator: validateSpaces }
                                    ]}
                                >
                                    <Select 
                                        placeholder="Select a property" 
                                        onChange={(e) => handlePropertyType(e)}
                                        showSearch
                                        filterOption={(input, option) =>
                                            option?.children?.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {propertyData.map((option) => (
                                            <Option key={option.id} value={option.id}>{option.name}</Option>
                                        ))}
                                    </Select>
                                </Item>
                            </Col>
                            <Col span={5} className='p-2'>
                                <Item
                                    label="Type"
                                    name="property_type"
                                >
                                    <Input disabled/>
                                </Item>
                            </Col>
                            <Col span={6} className='p-2'>
                                <Item
                                  label="Address"
                                  name="property_address"
                                >
                                    <Input disabled/>
                                </Item>
                            </Col>
                        </Row>
                        {
                            rentalDetails?.property_type !== "Raw Lot" && (
                                <Row className='responsive-inline responsive-width'>
                                    <Col span={8} className='p-2'>
                                        <Item
                                            label="Floor Area"
                                            name="floor_area"
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                    <Col span={4} className='p-2'>
                                        <Item
                                            label="Bedrooms"
                                            name="bedrooms"
                                            rules={[
                                                { required: true, message: 'Please enter your Bedrooms!' },
                                                { validator: validateSpaces }
                                            ]}
                                        >
                                            <Select 
                                                placeholder="Select a Bedroom" 
                                                showSearch
                                                filterOption={(input, option) =>
                                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                                }
                                            >
                                                {bedrooms_data.map((option) => (
                                                    <Option key={option.id} value={option.name}>{option.name}</Option>
                                                ))}
                                            </Select>
                                        </Item>
                                    </Col>
                                    <Col span={4} className='p-2'>
                                        <Item
                                            label="Bathrooms"
                                            name="bathrooms"
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                    <Col span={8} className='p-2'>
                                        <Item
                                            label="Furnished"
                                            name="furnishing"
                                            rules={[
                                                { required: true, message: 'Please pick a furnished!' },
                                                { validator: validateSpaces }
                                            ]}
                                        >
                                            <Radio.Group>
                                                {options.map((option) => (
                                                    <Radio key={option.value} value={option.value}>
                                                    {option.label}
                                                    </Radio>
                                                ))}
                                            </Radio.Group>
                                        </Item>
                                    </Col>
                                </Row>
                            )
                        }
                        <Row className='responsive-inline responsive-width'>
                            <Col span={8} className='p-2'>
                                <Item
                                    label="Pricing Type"
                                    name="pricing_type"
                                    rules={[
                                        { required: true, message: 'Please select your Pricing Type' },
                                        { validator: validateSpaces }
                                    ]}
                                >
                                    <Select onChange={handlePricingTypeChange} placeholder="Select a Pricing Type">
                                        <Option value="som">per SQM</Option>
                                        <Option value="unit">per Unit</Option>
                                    </Select>
                                </Item>
                            </Col>
                            {
                                rentalDetails.pricing_type === "som" && (
                                    <>
                                        <Col span={6} className='p-2'>
                                            <Item
                                                label="Space Area (sqm)"
                                                name="space_area"
                                                rules={[
                                                    { required: true, message: 'Please select your Space Area' },
                                                    { validator: validateSpaces }
                                                ]}
                                            >
                                                <Input/>
                                            </Item>
                                        </Col>
                                        <Col span={5} className='p-2'>
                                            <Item
                                                label="Cusa Area (sqm)"
                                                name="cusa_area"
                                            >
                                                <Input/>
                                            </Item>
                                        </Col>
                                        <Col span={5} className='p-2'>
                                            <Item
                                                label="Alfresco Area (sqm)"
                                                name="alfresco_area"
                                            >
                                                <Input/>
                                            </Item>
                                        </Col>
                                    </>
                                ) 
                            }
                            {
                                rentalDetails.pricing_type === "unit" && (
                                  
                                    <Col span={8} className='p-2'>
                                        <Item
                                            label="Unit Price"
                                            name="unit_price"
                                            rules={[
                                                { required: true, message: 'Please enter your Unit Price!' },
                                                { validator: validateSpaces }
                                            ]}
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                        
                                ) 
                            }
                            <Col span={8} className='p-2'>
                                <Item
                                    label="Details"
                                    name="description"
                                >
                                    <Input/>
                                </Item>
                            </Col>
                            <Col span={8} className='p-2'>
                                <Item
                                    label="With Insurance"
                                    name="with_insurance"
                                    rules={[{ required: true, message: 'Please pick a With Insurance!' }]}
                                >
                                    <Radio.Group>
                                        {insurance.map((option) => (
                                            <Radio key={option.value} value={option.value}>
                                            {option.label}
                                            </Radio>
                                        ))}
                                    </Radio.Group>
                                </Item>
                            </Col>
                        </Row>
                        <Row  className='responsive-inline responsive-width'>
                            <Divider className='divider-text'>Owner Information</Divider>
                            <Col span={8} className='p-2'>
                                <Item
                                    label="Owner Name"
                                    name="owner_id"
                                    showSearch
                                    rules={[
                                        { required: true, message: 'Please enter your Owner Name!' },
                                        { validator: validateSpaces }
                                    ]}
                                    filterOption={(input, option) =>
                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    <Select 
                                        onChange={handleOwnerType} 
                                        placeholder="Select a Owner"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option?.children?.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {ownerData.map((option, index) => (
                                            <Option key={index} value={option.id}>{option.name}</Option>
                                        ))}
                                    </Select>
                                </Item>

                                {/* <Switch
                                    checked={isManage}
                                    checkedChildren="Manage"
                                    unCheckedChildren="Not Manage"
                                    size='medium'
                                    // className='mt-2'
                                    style={{ backgroundColor: isManage ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                    onChange={() => {
                                        setIsManage(!isManage);
                                    }}
                                /> */}
                                   
                            </Col>
                            <Col span={8} className='p-2'>
                                <Item
                                    label="Contact Number"
                                    name="contact_no"
                                    
                                >
                                    <Input disabled/>
                                </Item>
                            </Col>
                            <Col span={8} className='p-2'>
                                <Item
                                    label="Address"
                                    name="address"
                                >
                                    <Input disabled/>
                                </Item>
                            </Col>
                            <Col span={8} className='p-2'>
                                <Item
                                    label="Remark"
                                    name="remark"
                                >
                                    <Input/>
                                </Item>
                            </Col>
                        </Row>
                        {/* {
                            isManage ?
                            (
                                <Row  className='responsive-inline responsive-width'>
                                    <Divider className='divider-text'>Fees</Divider>
                                    <Col span={8} className='p-2'>
                                        <Space>
                                        <Item
                                            label="Management Fee"
                                            name="management_fee"
                                        >
                                            <Input/>
                                        </Item>
                                        <Switch
                                            checked={manageType}
                                            checkedChildren="Percentage"
                                            unCheckedChildren="Fixed Price"
                                            size='medium'
                                            // className='mt-2'
                                            style={{ backgroundColor: manageType ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                            onChange={() => {
                                                setManageType(!manageType);
                                            }}
                                        />
                                        </Space>
                                    </Col>
                                    <Col span={8} className='p-2'>
                                        <Item
                                            label="Agent Fee"
                                            name="agent_fee"
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                </Row>
                            ) : (
                                <Row  className='responsive-inline responsive-width'>
                                    <Divider className='divider-text'>Manage</Divider>
                                    <Col span={8} className='p-2'>
                                        <Item
                                            label="Agent Fee"
                                            name="agent_fee"
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                </Row>
                            )
                        } */}
                                   
                        <Row className='btn-footer'>
                            <Space className='p-2'>
                                <Button
                                onClick={() => navigate('/rental-unit')}
                                className='cancel-color btn-header'
                                >
                                Cancel
                                </Button>
                                <Button
                                onClick={handleAddRentalUnit}
                                loading={loading}
                                type='primary'
                                className='button-color btn-header'
                                >
                                Save
                                </Button>
                            </Space>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Layout>
    </Layout>
  )
}

export default AddRentalUnit
